module.exports = __webpack_public_path__ + "media/images/emblems/Comano-coat_of_arms-0493e1575d7cbb4327e89dd4d2e9910c.svg";